export enum TourType {
  BOOK_A_TOUR = 'TOUR',
  CLUB_WELCOME = 'CLUB_WELCOME',
  TRIAL = 'TRIAL',
}
